import { apiDate } from "@/api/apicommon";

const CONTROL_KEYS = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Delete', 'Alt', 'Tab', 'Backspace', 'Shift']

export default {
  isControlKey(key) {
    return CONTROL_KEYS.includes(key)
  },
  onlyInteger(e) {
    // Allow all ctrl/cmd shortcuts (copy, paste, select all, undo, etc.)
    if (e.ctrlKey || e.metaKey) return true
    // Handle paste
    if (e.type === 'paste') {
      e.preventDefault()
      const pasted = (e.clipboardData || window.clipboardData).getData('text')
      const sanitized = pasted.replace(/\D/g, '')
      document.execCommand('insertText', false, sanitized)
      return
    }
    // Allow digits and control keys only
    if (!/\d/.test(e.key) && !CONTROL_KEYS.includes(e.key)) {
      e.preventDefault()
      return false
    }
    return true
  },
  onlyIntegeWithPaste(e) {
    // Allow all ctrl/cmd shortcuts (copy, paste, select all, undo, etc.)
    if (e.ctrlKey || e.metaKey) return true
    // Handle paste
    if (e.type === 'paste') {
      e.preventDefault()
      const pasted = (e.clipboardData || window.clipboardData).getData('text')
      const sanitized = pasted.replace(/\D/g, '')
      document.execCommand('insertText', false, sanitized)
      return
    }
    // Allow digits and control keys only
    if (!/\d/.test(e.key) && !CONTROL_KEYS.includes(e.key)) {
      e.preventDefault()
      return false
    }
    return true
  },
  onlyNumber(e) {
    // Allow all ctrl/cmd shortcuts (copy, paste, select all, undo, etc.)
    if (e.ctrlKey || e.metaKey) return true
    const decimalSeparators = ['.', ',']
    const permittedKeys = ['-', ...CONTROL_KEYS]
    // Handle paste
    if (e.type === 'paste') {
      e.preventDefault()
      const pasted = (e.clipboardData || window.clipboardData).getData('text')
      let sanitized = pasted
        .replace(/[^0-9.,-]/g, '')           // Strip invalid characters
        .replace(/(?!^)-/g, '')               // Remove minus signs not at the start
        .replace(/([.,].*)[.,]/g, '$1')       // Keep only the first decimal separator
      const { value, selectionStart, selectionEnd } = e.target
      const remainingValue = value.substring(0, selectionStart) + value.substring(selectionEnd)
      // Strip minus from pasted content if it won't end up at position 0
      if (selectionStart !== 0) {
        sanitized = sanitized.replace('-', '')
      }
      // If there's already a minus in the part that won't be replaced, strip it from pasted
      if (remainingValue.includes('-')) {
        sanitized = sanitized.replace('-', '')
      }
      // Check for decimal separator only in the text that will remain after replacement
      if (decimalSeparators.some(sep => remainingValue.includes(sep))) {
        sanitized = sanitized.replace(/[.,]/g, '')
      }
      document.execCommand('insertText', false, sanitized)
      return
    }
    // Allow minus only at the start
    if (e.key === '-') {
      const { value, selectionStart, selectionEnd } = e.target
      const remainingValue = value.substring(0, selectionStart) + value.substring(selectionEnd)
      if (remainingValue.includes('-') || selectionStart !== 0) {
        e.preventDefault()
        return false
      }
      return true
    }
    // Allow only one decimal separator
    if (decimalSeparators.includes(e.key)) {
      const { value, selectionStart, selectionEnd } = e.target
      const remainingValue = value.substring(0, selectionStart) + value.substring(selectionEnd)
      if (decimalSeparators.some(sep => remainingValue.includes(sep))) {
        e.preventDefault()
        return false
      }
      return true
    }
    // Allow digits and control keys only
    if (!/[0-9]/.test(e.key) && !permittedKeys.includes(e.key)) {
      e.preventDefault()
      return false
    }
    return true
  },
  convertRemToPixels(rem) {
    return rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
  },
  arrSwitch(idSTR, arr) {
    let index = arr.indexOf(idSTR)
    index > -1 ? arr.splice(index, 1) : arr.push(idSTR)
  },
  capitalize(text) {
    if (text.length > 0) {
      text = text.charAt(0).toUpperCase() + text.slice(1);
    }
    return text
  },
  label(name = "Generic", dbId = "") {
    let content = {}
    content.text = name
    content.id = this.newId(name, 1, dbId)
    return content
  },
  newId(uiTypeSTR, uiIndexSTR) {
    let id = {}
    id.uiIndex = uiIndexSTR
    id.ui = uiTypeSTR + "_" + id.uiIndex
    return id
  },
  /**
   * Deeply clones a given value using the structuredClone API.
   *
   * @template T
   * @param {T} ARR - The value to deeply copy.
   * @returns {T} A deep cloned copy of the input value.
   */
  deepCopy(ARR){
    return structuredClone(ARR);  // eslint-disable-line no-undef
  },
  dateStrInMs(dateSTR) {
    let year = dateSTR.slice(-4)
    let monthIndex = dateSTR.slice(3, 5) - 1 // monthIndex = month -1
    let day = dateSTR.slice(0, 2)
    return new Date(year, monthIndex, day).getTime()
  },

  getLocationUrl(address) {
    const addressArr = [address.street, address.postalCode, address.locality, address.country].join(' ')
    return 'https://www.google.fr/maps/place/' + addressArr.replaceAll(' ', '+')
  },

  getTelUrl(phone, phonePrefix) {
    return 'tel:+' + phonePrefix + phone;
  },

  getEmailUrl(email) {
    return 'mailto:' + email;
  },

  async downloadBlob(blob, fileName, fileExtension) {
    //Create fullFillName
    if (!fileName) fileName = "file"
    const fileFullName = fileExtension
      ? fileName + "." + fileExtension
      : fileName
    //Download
    var blobUrl = URL.createObjectURL(blob)
    var link = document.createElement('a')
    link.href = blobUrl
    link.download = fileFullName
    link.click()
    setTimeout(function() {
      link.remove();
    }, 10000);
    URL.revokeObjectURL(blobUrl);
  },

  printBlob(blob, fileType) {
    switch (fileType) {
      case "Pdf":
        this.printPdfBlob(blob)
        break
      case "Image":
        this.printImgBlob(blob)
        break
    }
  },

  async printPdfBlob(blob) {
    if (!blob) {return}
    const pdfBlob = new Blob([blob], {type: 'application/pdf'});
    const blobUrl = URL.createObjectURL(pdfBlob);
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = blobUrl;
    document.body.appendChild(iframe);
    iframe.onload = function() {
      setTimeout(() => {
        iframe.contentWindow.print();
      }, 100);
      setTimeout(() => {
        if (document.body.contains(iframe)) {
          document.body.removeChild(iframe);
          URL.revokeObjectURL(blobUrl);
        }
      }, 300000);
    };
  },

  async printImgBlob(blob) {
    if (!blob) {return}
    const fileReader = new FileReader()
    fileReader.onload = function (event) {
      const content = event.target.result
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      document.body.appendChild(iframe)
      iframe.contentDocument.write('<html><head></head><body style="margin:0;"><div>')
      iframe.contentDocument.write('<img src="' + content + '" style="max-width: 100%; max-height: 100%;" />')
      iframe.contentDocument.write('</div></body></html>')
      iframe.contentDocument.close()
      iframe.contentWindow.print()
      document.body.removeChild(iframe)
    }
    fileReader.readAsDataURL(blob)
  },
  shortRelativeDate(interestDateString, referenceDateString) {
    // Get dates
    const interestDate = apiDate(interestDateString)
    const referenceDate = apiDate(referenceDateString)

    // Calculate the time difference in milliseconds
    const timeDifference = referenceDate - interestDate
    
    // Calculate the number of years, months, weeks, and days
    const years = timeDifference / (365 * 24 * 60 * 60 * 1000)
    const months = timeDifference / (30 * 24 * 60 * 60 * 1000)
    const weeks = timeDifference / (7 * 24 * 60 * 60 * 1000)
    const days = Math.floor(timeDifference / (24 * 60 * 60 * 1000));
    
    // Return
    if (timeDifference < 0 && days < -1) {
      return "futur"
    } else if (years > 1) {
      return  interestDate.getFullYear().toString();
    } else if (months > 1) {
      return  Math.floor(months) + " mois"
    } else if (weeks > 1) {
      return  Math.floor(weeks) + " semaine"  + (Math.floor(weeks) > 1 ? "s" : "");
    } else if (days <= 1) {
      return  "actuel"
    } else {
      return days + " jour" + (days > 1 ? "s" : "");
    }
  },
  getAssessementTypeTerm(assessmentType) {
    switch (assessmentType) {
      case "Presentation":
        return "Tableau"
      case "Etiology":
        return "Etio"
      case "Complication":
        return "Complic"
      case "Indication":
        return "Indic"
      case "Treatment":
        return "Traitement"
      case "Concept":
        return "Concept"
      case "Context":
        return "Contexte"
      case "Vaccinations":
        return "Vaccins"
      default:
        console.error("Invalid assessmentType")
        return ""
    }
  },
  
  extractFilenameFromHeaders(headers) {
      if (!headers) return null
      const contentDisposition = headers.get('Content-Disposition');
      if (!contentDisposition) return null
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
      if (!filenameMatch || !filenameMatch[1]) return null;
      const headerFilename = filenameMatch[1].replace(/['"]/g, '');
      if (!headerFilename) return null;
      // Split filename and extension
      const lastDotIndex = headerFilename.lastIndexOf('.');
      if (lastDotIndex > 0) {
          return {
              fileName: headerFilename.substring(0, lastDotIndex),
              fileExtension: headerFilename.substring(lastDotIndex + 1)
          }
      } else {
          return {
              fileName: headerFilename,
              fileExtension: null
          }
      }
  },

  createDebouncedFn(fn, delay) {
    let timer = null
    let pendingArgs = null

    function debounced(...args) {
      pendingArgs = args
      clearTimeout(timer)
      timer = setTimeout(() => {
        pendingArgs = null
        fn(...args)
      }, delay)
    }

    debounced.flush = () => {
      if (pendingArgs) {
        clearTimeout(timer)
        const args = pendingArgs
        pendingArgs = null
        fn(...args)
      }
    }

    return debounced
  },
  
  // findClosestExpression(doseTiming, conceptExpressions) {
  //   if (conceptExpressions.length === 0) {return {}}
  //   let closestExpr = null
  //   let lastTimeDiff = null
  //   let lastUpdateTime = null
  //   const currDoseDate = new Date(doseTiming.timelineStart)
  //   const nextDoseDate = doseTiming.nextDose?.timelineStart
  //     ? new Date(doseTiming.nextDose.timelineStart)
  //     : null
  //   for (const expr of conceptExpressions) {
  //     const exprDate = new Date(expr.timelineStart)
  //     const updateTime = new Date(expr.updated)
  //     if (nextDoseDate && exprDate > nextDoseDate) continue;
  //     const timeDiff = exprDate - currDoseDate
  //     if (lastTimeDiff === null || (timeDiff >= lastTimeDiff && updateTime > lastUpdateTime)) {
  //       closestExpr = expr
  //       lastTimeDiff = timeDiff
  //       lastUpdateTime = updateTime
  //     }
  //   }
  //   return closestExpr
  // },


}
